export const LIST_GHOST_PRODUCTS_REQUESTED = 'LIST_GHOST_PRODUCTS_REQUESTED';
export const LIST_GHOST_PRODUCTS_SUCCEEDED = 'LIST_GHOST_PRODUCTS_SUCCEEDED';

export const CREATE_GHOST_PRODUCTS_REQUESTED = 'CREATE_GHOST_PRODUCTS_REQUESTED';
export const CREATE_GHOST_PRODUCTS_SUCCEEDED = 'CREATE_GHOST_PRODUCTS_SUCCEEDED';
export const CREATE_GHOST_PRODUCTS_COMPLETED = 'CREATE_GHOST_PRODUCTS_COMPLETED';

export const PRINT_GHOST_PRODUCT_REQUESTED = 'PRINT_GHOST_PRODUCT_REQUESTED';
export const PRINT_GHOST_PRODUCT_SUCCEEDED = 'PRINT_GHOST_PRODUCT_SUCCEEDED';
export const PRINT_GHOST_PRODUCT_COMPLETED = 'PRINT_GHOST_PRODUCT_COMPLETED';
